import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";

import { useLastEventByQuery } from "src/features/events";
import { yesNoMessages } from "src/messages/generic";

export function useDm(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<string>(queries.diabetes);
	const { formatMessage } = useIntl();

	return event === undefined
		? { value: "-" }
		: {
				value: formatMessage(yesNoMessages.YES),
				timestamp: event.timestamp,
				origin: event.origin
			};
}
